<div [innerHTML]="banner"></div>

<ks-shrink-wrap minScale="84%">
  <div class="details">
    <p-fieldset legend="Detailed settings" [toggleable]="true" [(collapsed)]="detailsCollapsed">
      <div class="boolean-options">
        <p-checkbox [binary]="true" label="colorize"
            [(ngModel)]="prefs.colorize" (onChange)="onChange()"></p-checkbox>
        <p-checkbox [binary]="true" label="darkMode"
            [(ngModel)]="prefs.darkMode" (onChange)="updatePrefs()"></p-checkbox>
        <p-checkbox [binary]="true" label="reformat"
            [(ngModel)]="prefs.reformat" (onChange)="onChange()"></p-checkbox>
        <p-checkbox [binary]="true" label="showWhitespace"
            [disabled]="!prefs.colorize"
            [(ngModel)]="prefs.showWhitespace" (onChange)="onChange()"></p-checkbox>
      </div>

      <span class="labeled-dropdown">
        <label>valueQuoting:</label>
        <p-dropdown [options]="quoting" placeholder="quoting"
            [disabled]="!prefs.reformat"
            [(ngModel)]="prefs.quoting" (onChange)="onChange()"></p-dropdown>
      </span>

      <span class="labeled-dropdown">
        <label>valueQuoteStyle:</label>
        <p-dropdown [options]="quoteStyle" placeholder="quoteStyle"
            [disabled]="!prefs.reformat || !prefs.quoting"
            [(ngModel)]="prefs.quoteStyle" (onChange)="onChange()"></p-dropdown>
      </span>

      <span class="labeled-input">
        <label for="indent">indent:</label>
        <input id="indent"
            pInputText
            [class.error]="indentError && prefs.reformat"
            [disabled]="!prefs.reformat"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            [(ngModel)]="indent"
            (input)="onChange()">
      </span>

      <span class="labeled-dropdown">
        <label>alignAttributes:</label>
        <p-dropdown [options]="attributeAlignment" placeholder="attribute alignment"
            [disabled]="!prefs.reformat"
            [(ngModel)]="prefs.attributeAlignment" (onChange)="onChange()"></p-dropdown>
      </span>
    </p-fieldset>
  </div>
</ks-shrink-wrap>

<div class="panels">
  <div class="source">
    <h3>Source</h3>
    <div class="icons">
      <i class="fas fa-info-circle info" tooltipPosition="bottom" tooltipEvent="hover"
          [pTooltip]="inputInfo" [escape]="false" tooltipStyleClass="tooltip"
          (touchstart)="touchToHover($event)"></i>
      <i class="fas fa-trash" [class.faded]="!source" (click)="clearSource()"></i>
    </div>
  </div>

  <h3>Reparsed</h3>

  <textarea id='source-elem'
      pInputTextarea
      title="Source"
      [(ngModel)]="source"
      autocapitalize="off"
      autocomplete="off"
      autocorrect="off"
      class="code"
      rows="40"
      spellcheck="false"
      (paste)="onPaste($event)"
      (input)="onChange(true)"
      (scroll)="onScroll($event)"></textarea>

  <div *ngIf="prefs.colorize" id="output-elem-1"
      [innerHTML]="output"
      [ngClass]="{'dark-mode': prefs.darkMode, 'light-mode': !prefs.darkMode, 'new-line': endsInNewLine}"
      class="code html-output"
      (scroll)="onScroll($event)"></div>
  <div *ngIf="!prefs.colorize" id="output-elem-2"
      [innerText]="output"
      [ngClass]="{'dark-mode': prefs.darkMode, 'light-mode': !prefs.darkMode, 'new-line': endsInNewLine}"
      class="code html-output"
      (scroll)="onScroll($event)"></div>
</div>
